// extracted by mini-css-extract-plugin
export default {"file-upload-dropzone":"CreateEditAssessmentExercise_file-upload-dropzone__zlSw6"};